module.exports = __webpack_public_path__ + "img/list-title-251.ce7bff74.png";